var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import { useFormContext } from 'react-hook-form';
var Input = React.forwardRef((function (props, ref) {
    var _a, _b, _c;
    var id = props.id, label = props.label, labelClassName = props.labelClassName, error = props.error, textInput = props.textInput, _d = props.divClassName, divClassName = _d === void 0 ? '' : _d, _e = props.inputClassName, inputClassName = _e === void 0 ? '' : _e, borderShowFinalOnly = props.borderShowFinalOnly, borderShowFinalOnlyInput = props.borderShowFinalOnlyInput, _f = props.borderColor, borderColor = _f === void 0 ? '' : _f, _g = props.borderColorInput, borderColorInput = _g === void 0 ? '' : _g, icon = props.icon, rest = __rest(props, ["id", "label", "labelClassName", "error", "textInput", "divClassName", "inputClassName", "borderShowFinalOnly", "borderShowFinalOnlyInput", "borderColor", "borderColorInput", "icon"]);
    var _h = useFormContext(), errors = _h.errors, getValues = _h.getValues;
    var tmpValues = getValues();
    var value = tmpValues[id];
    var errorCondition = errors.hasOwnProperty(id) && errors[id].message;
    var successCondition = !errors.hasOwnProperty(id);
    var normalCondition = !value;
    var input = classNames((_a = {},
        _a['w-full relative z-10 bg-transparent input focus:outline-none'] = true,
        _a['resize-none'] = textInput,
        _a['border-2 border-red-600'] = borderShowFinalOnlyInput && errorCondition,
        _a['border-2 border-green-600'] = borderShowFinalOnlyInput && successCondition && value,
        _a['border-red-600'] = borderColorInput && errorCondition,
        _a['border-green-600'] = borderColorInput && successCondition && value,
        _a[borderColorInput] = borderColorInput && normalCondition,
        _a[inputClassName] = inputClassName,
        _a));
    var showError = classNames((_b = {},
        _b['mt-2 text-13 font-medium text-red-600'] = true,
        _b['hidden'] = !errorCondition,
        _b));
    var mainDiv = classNames((_c = {},
        _c[divClassName] = divClassName,
        _c['border-2 border-red-600'] = borderShowFinalOnly && errorCondition,
        _c['border-2 border-green-600'] = borderShowFinalOnly && successCondition && value,
        _c['border-red-600'] = borderColor && errorCondition,
        _c['border-green-600'] = borderColor && successCondition && value,
        _c[borderColor] = borderColor && normalCondition,
        _c));
    return (React.createElement("div", { className: mainDiv },
        icon ?
            icon
            : null,
        label ?
            React.createElement("label", { htmlFor: id, className: labelClassName }, label)
            : null,
        textInput ?
            React.createElement("textarea", __assign({ ref: ref, id: id, name: id, className: input }, rest))
            :
                React.createElement("input", __assign({ ref: ref, id: id, name: id, className: input }, rest)),
        errorCondition ?
            React.createElement("p", { className: showError }, errorCondition ? errors[id].message : error)
            : null));
}));
export default Input;
